import { PostNewsApi } from "@/features/news/services/post-news-api";
import { PostNewsRequestModel } from "@/features/news/services/post-news-model";

/// お知らせ既読情報登録処理
export class PostNewsService {
  private postNewsApi = new PostNewsApi();

  /**
   * お知らせ一覧取得API実行
   */
  public async postNews(param: PostNewsRequestModel) {
    return await this.postNewsApi.postNews(param);
  }
}
